@if (iframeSource) {
  <iframe
    #appIframe
    class="data-iframe"
    [src]="iframeSource"
    title="Application Frame"
    allow="clipboard-write"
    (load)="handleIframeLoad($event)"
    (error)="handleIframeLoad($event)"
  ></iframe>
}
